import moment from 'moment';
import {
  FETCH_TASKS,
  COMPLETE_TASK,
  ADD_TASK,
  UPDATE_TASK,
  UPDATE_TASK_OCCURRENCE,
  FETCH_RULES,
  CLEAR_TODOS_ACTION } from './types';

const BACKEND_API = 'BACKEND_API';


export const fetchTasks = (page, filters) => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/tasks/occurrences/${page ? '?page=' : ''}${page || ''}${filters ? '&filters=' : ''}${filters || ''}`
    },
    FETCH_TASKS
  )
});

export const fetchDelegatedTasks = (page, filters) => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/tasks/delegated/${page ? '?page=' : ''}${page || ''}${filters ? '&filters=' : ''}${filters || ''}`
    },
    FETCH_TASKS
  )
});

export const fetchRules = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/rules/'
    },
    FETCH_RULES
  )
});

export const fetchCompletedTasks = (page, filters) => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: `/tasks/completed/${page ? '?page=' : ''}${page || ''}${filters ? '&filters=' : ''}${filters || ''}`
    },
    FETCH_TASKS
  )
});

export const completeTask = oc => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'post',
      url: `/tasks/${oc.event.id}/toggle_complete_task/`,
      data: {
        date: oc.original_end,
        email_date: moment().format()
      }
    },
    COMPLETE_TASK
  )
});

export const addTask = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/tasks/',
    data,
    ...ADD_TASK
  }
});

export const updateTask = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/tasks/${id}/`,
    data,
    ...UPDATE_TASK
  }
});

export const updateTaskOccurrence = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/tasks/${id}/update_occurrence/`,
    data,
    ...UPDATE_TASK_OCCURRENCE
  }
});


export const clear = () => ({
  type: CLEAR_TODOS_ACTION
});
